export default {
    PendingApproval:'pending',
}


// WEBPACK FOOTER //
// ./src/containers/userregistration/logic/requestStatus.js